function popup() {
    const showPopupBtn = document.querySelectorAll('.show-popup');

    if(showPopupBtn.length > 0) {
        const popup = document.querySelector('.popup');
        const closePopupBtn = document.querySelectorAll('.close-popup');

        showPopupBtn.forEach(el=> {
            el.addEventListener('click', function(e) {
                e.preventDefault();
                popup.classList.add('show');
            });
        });

        closePopupBtn.forEach(el=> {
            el.addEventListener('click', (e)=> {
                e.preventDefault();
                popup.classList.remove('show');
            });
        });

        document.addEventListener('click', (e)=> {
            if(e.target === popup) popup.classList.remove('show');
        });
    }


    /**
     * Welcome popup
     */
    const welcome = document.querySelector('.welcome');

    if (welcome) {
        // Проверка наличия класса hide при загрузке страницы
        // if (localStorage.getItem('welcomeHidden') === 'true') {
        //     welcome.classList.add('hide');
        // }

        const closeBtn = document.querySelector('.welcome__close');

        closeBtn.addEventListener('click', () => {
            welcome.classList.add('hide');
            // localStorage.setItem('welcomeHidden', 'true'); // Сохранение состояния в localStorage
        });

        document.addEventListener('click', (e) => {
            if (e.target && e.target.classList.contains('welcome')) {
                welcome.classList.add('hide');
                // localStorage.setItem('welcomeHidden', 'true'); // Сохранение состояния в localStorage
            }
        });
    }
}

export default popup;